/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderCheckBoxSelectListElement, HeaderListProps } from './HeaderCheckBoxSelectList';

const _ = require('underscore');

const yesNoValues = {
    YES: 1,
    NO: 2,
};

export const getBooleanElementList = (): Array<HeaderCheckBoxSelectListElement> => {
    const yes = {} as HeaderCheckBoxSelectListElement;
    const no = {} as HeaderCheckBoxSelectListElement;

    yes.value = yesNoValues.YES;
    yes.name = 'general:common.yes';
    no.value = yesNoValues.NO;
    no.name = 'general:common.no';
    return [yes, no];
};

class HeaderBooleanCheckBoxSelectList extends PureComponent<HeaderListProps> {
    handleChange = (numbers: Array<number>): void => {
        const { handleChange, fieldName } = this.props;
        const indexArray = [];
        if (_.indexOf(numbers, yesNoValues.YES) !== -1) {
            indexArray.push(true);
        }
        if (_.indexOf(numbers, yesNoValues.NO) !== -1) {
            indexArray.push(false);
        }
        if (indexArray.length === 1) {
            handleChange(fieldName, indexArray[0].toString());
        } else {
            handleChange(fieldName, []);
        }
    };

    render(): React.ReactNode {
        const { fieldName } = this.props;
        return <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={getBooleanElementList()} fieldName={fieldName} />;
    }
}

export default compose<any, any>(withStyles(adescomStyle))(HeaderBooleanCheckBoxSelectList);
